import { z } from 'zod/v4';

import { normalizeCrmCustomerPaymentsReturnTo } from './payment-return-context';
import { paymentTabs } from './tabs';

const paymentTabSchema = z
  .string()
  .trim()
  .transform((value) => paymentTabs.find((tab) => tab.toLowerCase() === value.toLowerCase()))
  .pipe(z.enum(paymentTabs));

const paymentSearchTextSchema = z.string().trim().max(200).optional().catch(undefined);

export const paymentsSearchSchema = z.object({
  detailTab: z.enum(['cart-items']).optional().catch(undefined),
  detailReturn: z
    .enum(['global', 'registration-profile', 'user-profile'])
    .optional()
    .catch(undefined),
  detailReturnCustomerId: z.uuid().optional().catch(undefined),
  detailReturnGlobalUserProfileId: z.uuid().optional().catch(undefined),
  detailReturnProfileOriginCustomerId: z.uuid().optional().catch(undefined),
  detailReturnProfileOriginPaymentQ: paymentSearchTextSchema,
  detailReturnProfileOriginUserProfilePaymentsReturnTo: z
    .string()
    .max(4096)
    .optional()
    .transform((value) => normalizeCrmCustomerPaymentsReturnTo(value)),
  detailReturnQ: paymentSearchTextSchema,
  detailReturnRegistrationCustomerId: z.uuid().optional().catch(undefined),
  detailReturnRegistrationId: z.uuid().optional().catch(undefined),
  detailReturnRegistrationReturnTo: z.string().max(4096).optional().catch(undefined),
  detailReturnUserProfilePaymentsReturnTo: z
    .string()
    .max(4096)
    .optional()
    .transform((value) => normalizeCrmCustomerPaymentsReturnTo(value)),
  profileOriginCustomerId: z.uuid().optional().catch(undefined),
  profileOriginPaymentQ: paymentSearchTextSchema,
  profileOriginUserProfilePaymentsReturnTo: z
    .string()
    .max(4096)
    .optional()
    .transform((value) => normalizeCrmCustomerPaymentsReturnTo(value)),
  tab: paymentTabSchema.optional().catch(undefined),
  q: paymentSearchTextSchema,
  userProfileId: z.uuid().optional().catch(undefined),
});

export type PaymentsSearch = z.infer<typeof paymentsSearchSchema>;
